import { hot } from 'react-hot-loader';
import React from 'react';
import View from './View';

const TermsComponent = ({ data, location }) => {
  return <View data={data} location={location} />
};

export const Terms = hot(module)(TermsComponent);
